import React, { useEffect, useReducer } from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';
import { getFocusQualityAndImage } from '../video.utils';
import { feedFocusQualitySample, initialState, reducer } from './reducer';

export interface FocusQualityIndicatorProps {
  video?: HTMLVideoElement;
  thresholdPercentage?: number;
  onNewThreshold?: (threshold: number) => void;
  hide?: boolean;
  className?: string;
}

function FocusQualityIndicator(props: FocusQualityIndicatorProps) {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    thresholdPercentage:
      props.thresholdPercentage || initialState.thresholdPercentage,
  });

  useEffect(() => {
    if (!state.isSampling) {
      return;
    }

    const intervalId = setInterval(() => {
      if (props.video) {
        const { focusQuality } = getFocusQualityAndImage(props.video);
        dispatch(feedFocusQualitySample(focusQuality, null));
      }
    }, 300);

    return () => {
      clearInterval(intervalId);
    };
  }, [props.video, state.isSampling]);

  useEffect(() => {
    console.log('New threshold', state.acceptanceThreshold);
    state.acceptanceThreshold &&
      props.onNewThreshold &&
      props.onNewThreshold(state.acceptanceThreshold);
  }, [state.acceptanceThreshold]);

  if (props.hide) {
    return null;
  }

  return (
    <div className={clsx(styles.root, props.className)}>
      Quality: {state.lastFocusQuality}
    </div>
  );
}

export default FocusQualityIndicator;
